import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import { CommentData } from "../../../../../api/api";
import "./Reply.scoped.scss";
import { useSetRecoilState, useRecoilValue } from "recoil";
import {
  connectSiteState,
  editCommentNumState,
  isEditState,
  parentsIdxState,
  popState,
  userInfoState,
  writingTypeState
} from "../../../../../atoms/atom";
import CommentsLoading from "../../../../common/loading/CommentsLoading";
import { useTranslation } from "react-i18next";
import { CommentsDeleteApi, useInfiniteScrollQuery } from "./replyApi/api";
import ReplyFrame from "./ReplyFrame";
import { loginKey, msgRedirectURL } from "../../../../../utils/CommonFunc";
import {
  NAVER_SIGN_IN_URL,
  SIGN_IN_URL
} from "../../../../../utils/config/Config";
import { isLauncherState, loginState } from "../../../../../atoms/userInfoAtom";

function Reply() {
  const { t } = useTranslation();
  const isLogin = useRecoilValue(loginState);
  const { idx, service_code } = useParams();
  const userInfo = useRecoilValue(userInfoState);
  const connectSite = useRecoilValue(connectSiteState);
  const setIsEdit = useSetRecoilState(isEditState);
  const setEditCommentNumState = useSetRecoilState(editCommentNumState);
  const setParentsIdx = useSetRecoilState(parentsIdxState);
  const setPopOpen = useSetRecoilState(popState);
  const setWritingType = useSetRecoilState(writingTypeState);
  const [nextPageBtn, setNextPageBtn] = useState(false);
  const [editingToggle, setEditingToggle] = useState<any>({});
  const [isMyArticle, setIsMyArticle] = useState(false);
  const props = { userInfo, idx };
  const isLauncher = useRecoilValue(isLauncherState);

  const { getBoard, getNextPage, getBoardIsSuccess, getNextPageIsPossible } =
    useInfiniteScrollQuery(props);

  useEffect(() => {
    if (getNextPageIsPossible) {
      setNextPageBtn(true);
    } else {
      setNextPageBtn(false);
    }
  }, [nextPageBtn, getBoard]);

  const openRereply = (idx: number) => {
    if (isLogin === false) {
      if (isLauncher) {
        window.app.vfunRequestLogin();
      } else {
        msgRedirectURL(
          t(loginKey),
          connectSite === "vfun"
            ? SIGN_IN_URL(service_code || "vfun")
            : NAVER_SIGN_IN_URL + service_code,
          "_self"
        );
      }
    } else {
      setParentsIdx(idx);
      setPopOpen(true);
      setWritingType("reply");
      setIsEdit(false);
    }
  };

  // const time = (i: string) => {
  //   let day = new Date(`${i}`);
  //   const month = day.getMonth() + 1;
  //   const date = day.getDate();
  //   const hour = String(day.getHours()).padStart(2, "0");
  //   const minutes = String(day.getMinutes()).padStart(2, "0");
  //   return `${month}월${date}일 ${hour}:${minutes}`;
  // };

  const handleArticleEditor = (writerUser: string, idx: number) => {
    setEditingToggle({
      [idx]: !editingToggle[idx]
    });
    if (isLogin === true) {
      // 로그인 + 내글 : 수정, 삭제만
      if (
        writerUser.toLocaleLowerCase() === userInfo.Userid.toLocaleLowerCase()
      ) {
        setIsMyArticle(true);
        // 로그인 + 남의글 : 신고만
      } else {
        setIsMyArticle(false);
      }
      // 로그인 안함
    } else {
      //로그인 후 이용하실 수 있습니다.
      setIsMyArticle(false);
      if (isLauncher) {
        window.app.vfunRequestLogin();
      } else {
        msgRedirectURL(
          t(loginKey),
          connectSite === "vfun"
            ? SIGN_IN_URL(service_code || "vfun")
            : NAVER_SIGN_IN_URL + service_code,
          "_self"
        );
      }
    }
  };

  const useDeleteMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(CommentsDeleteApi, {
      onSuccess: (api) => {
        queryClient.invalidateQueries(["comments_board_list"]);
        if (api.data.result !== 1) {
          alert(t(api.data.msg));
        }
      },
      onError: (error: any) => {
        alert(t(error.response.data.message));
      }
    });
  };

  const { mutate: deleteMutate } = useDeleteMutation();

  const deleteBoard = (board_idx: number, comment_idx: number) => {
    if (window.confirm(t("Would_you_like_to_delete_your_reply"))) {
      const props = { board_idx, comment_idx, userInfo };
      deleteMutate(props);
    } else {
      return false;
    }
  };

  const editBoard = (idx: number) => {
    setWritingType("reply");
    setIsEdit(true);
    setPopOpen(true);
    setEditCommentNumState(idx);
  };

  return (
    <div className="replys" id="Reply">
      <div className="reply">
        {getBoardIsSuccess ? (
          getBoard?.pages[0].result === 1 ? (
            Number(idx) === getBoard?.pages[0].boardpage[0].board_idx ? (
              getBoard?.pages.map((pageData) =>
                pageData.boardpage.map((i: CommentData) =>
                  // 부모 댓글
                  i.comment_idx === 0 ? (
                    <ReplyFrame
                      data={i}
                      key={i.idx}
                      type="reply"
                      handleArticleEditor={handleArticleEditor}
                      editingToggle={editingToggle}
                      setEditingToggle={setEditingToggle}
                      isMyArticle={isMyArticle}
                      editBoard={editBoard}
                      deleteBoard={deleteBoard}
                      openRereply={openRereply}
                    />
                  ) : (
                    // 자식 댓글
                    <ReplyFrame
                      data={i}
                      key={i.idx}
                      type="re-reply"
                      handleArticleEditor={handleArticleEditor}
                      editingToggle={editingToggle}
                      setEditingToggle={setEditingToggle}
                      isMyArticle={isMyArticle}
                      editBoard={editBoard}
                      deleteBoard={deleteBoard}
                      openRereply={openRereply}
                    />
                  )
                )
              )
            ) : (
              <CommentsLoading />
            )
          ) : null
        ) : // <CommentsLoading />
        null}
      </div>
      {nextPageBtn && getBoard?.pages[0].result === 1 ? (
        <div onClick={() => getNextPage()} className="moreBtn">
          {t("more_comments")}
        </div>
      ) : null}
    </div>
  );
}

export default Reply;
